import { render, staticRenderFns } from "./TemplateInfoSection.vue?vue&type=template&id=8225b00c&"
import script from "./TemplateInfoSection.vue?vue&type=script&lang=js&"
export * from "./TemplateInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports